import { IComboBoxOption } from "@fluentui/react";
import { List } from "linq.ts";
import { NativeType } from "./NativeType";

export interface INativeType {
    Section: string;
    Serie: string;
    Subserie: string;
    User: string;
    Role: string;
    Profile: string;
    Country: string;
    Department: string;
    City: string;
    Contact: string;
    Holiday: string;
    Gender: string;
    EthnicGroup: string;
    DocumentaryType: string,
    ArchivoxDocument: string,
    Expediente: string,
    InputFile: string,
    OutputFile: string,
    InternalComunication: string,
    IdentificacionType: string,
    ApplicationDocument: string,
    IsNativeType: (value: string) => boolean;
}

export const NativeTypeDataSource: IComboBoxOption[] = new List<IComboBoxOption>([
    { key: NativeType.Section, text: 'ArchivoX - Sección' },
    { key: NativeType.Serie, text: 'ArchivoX - Serie' },
    { key: NativeType.Subserie, text: 'ArchivoX - Subserie' },
    { key: NativeType.User, text: 'ArchivoX - Usuario' },
    { key: NativeType.Role, text: 'ArchivoX - Rol' },
    { key: NativeType.Profile, text: 'ArchivoX - Perfil' },
    { key: NativeType.Country, text: 'ArchivoX - País' },
    { key: NativeType.Department, text: 'ArchivoX - Departamento' },
    { key: NativeType.City, text: 'ArchivoX - Ciudad' },
    { key: NativeType.Contact, text: 'TramiteX - Contacto' },
    { key: NativeType.Holiday, text: 'TramiteX - DiaFestivo' },
    { key: NativeType.Gender, text: 'TramiteX - Genero' },
    { key: NativeType.EthnicGroup, text: 'TramiteX - GrupoEtnico' },
    { key: NativeType.DocumentaryType, text: 'ArchivoX - Tipo documental' },
    { key: NativeType.ArchivoxDocument, text: 'ArchivoX - Documento' },
    { key: NativeType.Expediente, text: 'ArchivoX - Expediente' },
    { key: NativeType.InputFile, text: 'TramiteX - Radicado de entrada' },
    { key: NativeType.OutputFile, text: 'TramiteX - Radicado de salida' },
    { key: NativeType.InternalComunication, text: 'TramiteX - Comunicado interno' },
    { key: NativeType.ApplicationDocument, text: 'ProcesoX - Documento (Aplicación)' },
]).OrderBy(o => o.text).ToArray();